import { useQuery } from '@tanstack/react-query'
import { SEEDBOT_BASE_URL, type SeedbotWallet } from './useSeedbotHealth'

export interface BundleConfig {
  enabled: boolean
  dextoroEnabled?: boolean
  pumpfunEnabled?: boolean
  subWalletCount: number
  totalSolPerLaunch: number
  jitoTipSol: number
}

export interface PumpfunHealthData {
  pumpfun: {
    enabled: boolean
    schedulerRunning: boolean
    launchesThisHour: number
    launchesTotal: number
    lastLaunchAt: string | null
    failuresTotal: number
  }
  autoLaunch?: {
    dextoro: boolean
    pumpfun: boolean
  }
  bundleConfig: BundleConfig
  wallets: SeedbotWallet[]
  uptime: number
  fetchedAt: number
}

const HEALTH_URL = `${SEEDBOT_BASE_URL}/health`

export function usePumpfunHealth() {
  return useQuery({
    queryKey: ['pumpfun-health'],
    queryFn: async (): Promise<PumpfunHealthData> => {
      const res = await fetch(HEALTH_URL)
      if (!res.ok) {
        throw new Error(`Health endpoint returned ${res.status}`)
      }
      const data = await res.json()
      return {
        pumpfun: data.pumpfun,
        autoLaunch: data.autoLaunch,
        bundleConfig: data.bundleConfig ?? { enabled: false, subWalletCount: 0, totalSolPerLaunch: 0, jitoTipSol: 0 },
        wallets: data.wallets,
        uptime: data.uptime,
        fetchedAt: Date.now(),
      }
    },
    staleTime: 15_000,
    refetchInterval: 30_000,
  })
}
